import { isProductionEnvironment } from '../helpers/is-production.helper';
export var logGroup = function (message, object, collapsed) {
    if (collapsed === void 0) { collapsed = false; }
    if (isProductionEnvironment())
        return;
    (collapsed ? console.groupCollapsed : console.group)(message);
    Object.entries(object).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        console.log("".concat(key, ": ").concat(value));
    });
    console.groupEnd();
};
